import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService {

  constructor(public http: HttpClient) { }

  login(request) {
    return this.http.post(environment.apiUrl + "oms_api/v1/login", request);
  }

  getAllStores() {
    return this.http.get(environment.apiUrl + "oms_api/v1/stores");
  }

  getSelectedStoreInfo(storeID) {
    return this.http.get(environment.apiUrl + "oms_api/v1/stores/" + storeID);
  }

  createNewStoreAPI(Request) {
    console.log(Request);
    return this.http.post(environment.apiUrl + "oms_api/v1/stores", Request);
  }

  updateSelecteStore(res, body) {
    console.log(res);
    console.log(body);
    return this.http.put(environment.apiUrl + "oms_api/v1/stores/" + res, body);
  }

  updateTheAddressOfSelectedStore(res, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/addresses/" + res, body);
  }
  deleteTheSelectedStore(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/stores/" + id);
  }

  // getListOfOrders() {
  //   return this.http.get(environment.apiUrl + "oms_api/v1/orders");
  // }
  getListOfOrders() {
    return this.http.get(environment.apiUrl + "oms_api/v1/orders/sfs");
  }
  
  getClickandCollect() {
    return this.http.get(environment.apiUrl + "oms_api/v1/cc_orders");
  }

  getAselectedOrderDetails(orderID) {
    return this.http.get(environment.apiUrl + "oms_api/v1/orders/" + orderID);
  }

  getAllOrderStatus() {
    return this.http.get(environment.apiUrl + "oms_api/v1/statuses");
  }
  updateTheOrderStatus(id, status_id) {
    return this.http.put(environment.apiUrl + "oms_api/v1/orders/" + id, status_id);
  }

  getAllCustomerInfo() {
    return this.http.get(environment.apiUrl + "oms_api/v1/customers");
  }

  getSpesificCustomerInfo(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/customers/" + id);
  }

  getAllCartInfo() {
    return this.http.get(environment.apiUrl + "oms_api/v1/user_carts");
  }
  getSelectedCartInfo(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/carts/" + id);
  }

  createSlotsForStore(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/slots", body);
  }

  getSelectedStoreSlots(res) {
    return this.http.get(environment.apiUrl + "oms_api/v1/stores/" + res + "/slots");
  }

  createFrequency(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/frequency", body);
  }

  getAllFrequency() {
    return this.http.get(environment.apiUrl + "oms_api/v1/frequency");
  }

  selectedFrequencyDetails(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/frequency/" + id);
  }

  updateTheFrequency(id, body) {
    console.log(id);
    return this.http.put(environment.apiUrl + "oms_api/v1/frequency/" + id, body);
  }
  deleteTheselectedFrequency(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/frequency/" + id);
  }

  createDeliveryOptions(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/delivery_option", body);
  }

  getAllDeliveryOptions() {
    return this.http.get(environment.apiUrl + "oms_api/v1/delivery_option");
  }

  selectedDeliveryOptionDetails(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/delivery_option/" + id);
  }

  updateTheDeliveryOptions(id, body) {
    console.log(id);
    return this.http.put(environment.apiUrl + "oms_api/v1/delivery_option/" + id, body);
  }

  createNewSubscription_typeAPI(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/delivery_option", body);
  }

  getAllRoles() {
    return this.http.get(environment.apiUrl + "oms_api/v1/roles");
  }

  adminCreateNewUser(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/oms_users", body);
  }

  getALLuserInformation() {
    return this.http.get(environment.apiUrl + "oms_api/v1/oms_users");
  }
  getSlectedUserDetails(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/oms_users/" + id);
  }

  updateTheStoreSlots(body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/slots", body);
  }

  updateTheSelectedUser(id, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/oms_users/" + id, body);
  }

  deleteTheSelectedUser(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/oms_users/" + id);
  }

  adminCreateNewRole(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/roles", body);
  }
  getListOfRoles() {
    return this.http.get(environment.apiUrl + "oms_api/v1/roles");
  }

  deleteTheSelectedRole(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/roles/" + id);
  }
  getTheSelectedRoleInformation(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/roles/" + id);
  }

  updatetheSelectedRole(id, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/roles/" + id, body);
  }

  deleteTheselectedDeliveryOption(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/delivery_option/" + id);
  }

  getAllSubscriptionDetails() {
    return this.http.get(environment.apiUrl + "oms_api/v1/subscriptions");
  }

  deleteTheselectedSubscriptionSerivece(id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/subscriptions/" + id);
  }

  createNewSubscription_service(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/subscriptions", body);
  }

  getSelectedSubscriptionAPI(id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/subscriptions/" + id);
  }

  updateTheselectedSubscription(id, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/subscriptions/" + id, body);
  }

  getAllRatingsAndReviews() {
    return this.http.get(environment.apiUrl + "oms_api/v1/orders/rating_and_reviews");
  }

  getAllScreensAPI() {
    return this.http.get(environment.apiUrl + "oms_api/v1/screens");
  }

  createNewPermission(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/permissions", body);
  }

  selectedUserPermissions(role_id) {
    return this.http.get(environment.apiUrl + "oms_api/v1/roles/" + role_id + "/permissions");
  }
  updateTheSelectedUserPerMissions(body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/permissions", body);
  }

  downloadCustomeorders(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/orders/filter", body);
  }

  downloadCustomCustomers(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/customers/filter", body);
  }
  downloadCustomeStores(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/stores/filter", body);
  }
  downloadCustomeCart(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/user_carts/filter", body);
  }
  downloadCustomeRatingAndReview(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/orders/rating_and_reviews/filter", body);
  }
  downloadCustomeOMSroles(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/roles/filter", body);
  }
  downloadCustomOMSUsers(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/oms_users/filter", body);
  }

  searchAPI(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/search", body);
  }

  walte(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/wallets/transactions", body);
  }

  dashboardAPI(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/dashboard", body);
  }
  getDashboardAPI() {
    return this.http.get(environment.apiUrl + "oms_api/v1/dashboard");
  }

  removeItems_from_order(orderID, itemID) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/orders/" + orderID + "/items/remove/" + itemID);
  }

  updateTheOrderByOMS(id, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/orders/" + id + "/items", body);
  }
  createDeliveryCharges(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/delivery_charges", body);
  }
  getDeliveryCharges() {
    return this.http.get(environment.apiUrl + "oms_api/v1/delivery_charges");
  }
  deleteTheDeliveryCharge(Id) {
    return this.http.delete(environment.apiUrl + "oms_api/v1/delivery_charges/" + Id);
  }
  updateBulk(body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/orders/update", body);
  }

  getAllCCstatus() {
    return this.http.get(environment.apiUrl + "oms_api/v1/cc_statuses");
  }

  createminOrderVal(body) {
    return this.http.post(environment.apiUrl + "oms_api/v1/min_orders_value", body);
  }

  getMinimumOrderValueInfo() {

    return this.http.get(environment.apiUrl + "oms_api/v1/min_orders_value");

  }
  updateMiniOrderval(id, body) {
    return this.http.put(environment.apiUrl + "oms_api/v1/min_orders_value/" + id, body);
  }

} 
